export const MetrikaGoals = {
  SHOWN: 'SharedOrderCard.Shown',
  TAPPED: 'SharedOrderCard.Tapped',
  SUCCESS: 'SharedOrderCard.Success',
  FAILURE: 'SharedOrderCard.Failure',
} as const
